<script>
	import { page } from "$app/stores";
	import { PUBLIC_APP_NAME } from "$env/static/public";
	import { trimEllipsis } from "$lib/utils";

	/** @type {string?} */ export let title = null;
	/** @type {string?} */ export let description = null;
	/** @type {URL?} */ export let url = $page.url;
	/** @type {string?} */ export let type = "website";
	/** @type {string?} */ export let imageUrl = null;
	/** @type {number?} */ export let imageWidth = null;
	/** @type {number?} */ export let imageHeight = null;

	let fullTitle = `${!!title ? trimEllipsis(title, 70) + " - " : ""}${PUBLIC_APP_NAME}`;
	let fullImageUrl = imageUrl || "/apple-touch-icon.png";
	let trimDescription = trimEllipsis(description, 200);
</script>

<svelte:head>
	<!-- HTML Meta Tags -->
	<title>{fullTitle}</title>
	{#if trimDescription}
		<meta name="description" content={trimDescription} />
	{/if}

	<!-- Open Graph Meta Tags -->
	{#if url}
		<meta property="og:url" content={url.href} />
	{/if}
	{#if type}
		<meta property="og:type" content={type} />
	{/if}
	<meta property="og:title" content={fullTitle} />
	{#if trimDescription}
		<meta property="og:description" content={trimDescription} />
	{/if}
	<meta property="og:image" content={fullImageUrl} />
	{#if imageWidth}
		<meta property="og:image:width" content={imageWidth.toString()} />
	{/if}
	{#if imageHeight}
		<meta property="og:image:height" content={imageHeight.toString()} />
	{/if}

	<!-- Twitter Meta Tags -->
	<meta name="twitter:card" content="summary_large_image" />
	{#if url}
		<meta property="twitter:domain" content={url.hostname} />
		<meta property="twitter:url" content={url.href} />
	{/if}
	<meta name="twitter:title" content={fullTitle} />
	{#if trimDescription}
		<meta name="twitter:description" content={trimDescription} />
	{/if}
	<meta name="twitter:image" content={fullImageUrl} />
</svelte:head>
